import { useEffect, useState } from "react";
import { gql } from '@apollo/client';
import { useProtectedRoute } from "@netfront/gelada-identity-library";

import { CONSTANTS } from "@/constants";
import { IGetUserFlowByUrlUserSteps, useGetUserFlowByUrl } from "../useGetUserFlowByUrl";
import { IUseGetLessons } from "./useGetLessons.interfaces";

export const useGetLessons = (): IUseGetLessons => {
  const { isAuthenticated } = useProtectedRoute({
    redirectUrl: '/login',
  });

  const [lessons, setLessons] = useState<IGetUserFlowByUrlUserSteps[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { handleGetUserFlowByUrl } = useGetUserFlowByUrl({
    onCompleted: ({ userFlow: { userFlowSteps }}) => {
      if(!userFlowSteps) return;
      setLessons([...userFlowSteps].sort((a, b) => a.sort - b.sort));
      setIsLoading(false);
    },
    onError: () => {
      console.error('Failed to fetch lessons');
      setIsLoading(false);
    },
    query: gql`
      query getUserFlowByUrl($projectId: String!, $url: String!) {
        userFlow {
          getUserFlowByUrl(projectId: $projectId, url: $url) {
            id
            descriptionContentGroup {
              id
              title
              linkedAssets {
                assetId
                fileName
                contentType
                presignedUrl
              }
            }
            userFlowSteps {
              contentGroup {
                iconAsset {
                  presignedUrl
                }
                description
                sort
                title
                linkedAssets {
                  title
                  presignedUrl
                  tagList {
                    name
                  }
                }
              }
              id
              isComplete
              lastViewedContentPage {
                url
              }
              percentageCompleted
              sort
              stepName
              url
             
            }
          }
        }
      }
    `
  });

  useEffect(() => {
    if(!isAuthenticated) return;

    handleGetUserFlowByUrl({
      projectId: String(process.env.REACT_APP_PROJECT_ID),
      url: CONSTANTS.USERFLOW.CARTOONS.URL,
    });
  }, [isAuthenticated]);


  return {
    lessons,
    isLoading
  }
}